import React from 'react';

import Skeleton from 'components/Skeleton';

const StoriesCarouselSkeleton = () => {
  return (
    <div
      className="StoriesCarouselSkeleton"
      data-testid="stories-carousel-skeleton"
    >
      <Skeleton className="h-tile w-tile" />
    </div>
  );
};

export default StoriesCarouselSkeleton;
